import script from "./HealthCheckView.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthCheckView.vue?vue&type=script&setup=true&lang=js"

import "./HealthCheckView.vue?vue&type=style&index=0&id=070ee6be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070ee6be"]])

export default __exports__